export default function InitAnchors() {
  /*
   * You can define data-anchors on elements with the URL parameter attached
   * Example: data-anchor="tx_productcataloguesaf_solutioncatalogue[vehicleType]"
   */
  const anchors = document.querySelectorAll('[data-anchor]');
  if (anchors.length === 0) {
    return;
  }

  const searchParameters = new URLSearchParams(window.location.search);
  for (const anchor of anchors) {
    const anchorParameterName = anchor.getAttribute('data-anchor');
    if (
      anchorParameterName === null ||
      !searchParameters.has(anchorParameterName)
    ) {
      continue;
    }
    anchor.scrollIntoView({ behavior: 'smooth' });
  }
}
